import { render, staticRenderFns } from "./CxButton.vue?vue&type=template&id=3c48cb40&"
import script from "./CxButton.vue?vue&type=script&lang=js&"
export * from "./CxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports